import { createFileRoute } from "@tanstack/react-router";
import { PayPage } from "@/features/public-pay/PayPage";

/** Public pay page for one invoice. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/p/pay/$token")({
  component: PayRoute,
});

function PayRoute() {
  const { token } = Route.useParams();
  return <PayPage token={token} />;
}
